// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_2op-z","avatar":"index_avatar_3NJPx","menuIcon":"index_menuIcon_3J_bl","menuItem":"index_menuItem_xBvYb"};